import React, { useState } from "react"
import Select, { components } from "react-select"

import ArrowDown from "../../images/icons/wdn-arrow-down.png"

import "./multiple-checkbox.scss"

const MultipleCheckbox = props => {
  const [showPlaceholder, setShowPlaceholder] = useState(true)

  const onAddition = tag => {
    props.handleChange(tag)
  }

  const handleInputChange = e => {
    if (!e) {
      setShowPlaceholder(true)
    } else {
      setShowPlaceholder(false)
    }
  }

  return (
    <div className="form-group-select-container multiple-checkbox position-relative">
      <label>
        {props.label} {props?.extra ? " : " + props.extra : ""}
      </label>
      <Select
        className={"react-select-tags " + props.styles}
        classNamePrefix="react-select-tags"
        {...props}
        allowSelectAll
        isMulti
        placeholder={showPlaceholder ? props.placeholder : ""}
        components={{
          DropdownIndicator: DropdownIcon,
          ClearIndicator,
          ValueContainer: getComponents(props),
          MultiValue: CustomMultiValue,
          Option,
        }}
        onInputChange={handleInputChange}
        onChange={onAddition}
        value={props.value}
        options={props.options}
      />
    </div>
  )
}

const getComponents = props => {
  if (props.withCheckbox) return CustomValueContainer
  return
}
const CustomMultiValue = () => {
  return <></>
}
const CustomValueContainer = ({ children, ...props }) => {
  const { ValueContainer, Placeholder } = components
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  )
}

const DropdownIcon = () => {
  return (
    <img
      className="dropdown-arrow pr-3 pl-3"
      src={ArrowDown}
      alt="wdn-arrow-down"
    />
  )
}

const ClearIndicatorIcon = () => {
  return <span className="clear-indicator  blue-text">Clear</span>
}

const Option = props => {
  return (
    <>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </>
  )
}

const ClearIndicator = props => {
  const {
    children = <ClearIndicatorIcon />,
    innerProps: { ref, ...restInnerProps },
  } = props
  return (
    <div className="position-absolute indicator" {...restInnerProps} ref={ref}>
      <div>{children}</div>
    </div>
  )
}

export default MultipleCheckbox
